// import { isDev } from '@/utils/helper'

export default {
  MenuItems: true
}
